import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const ProtectedRoute: React.FC = () => {
  const { user, loading, isProcessing } = useAuth();

  const [showRetry, setShowRetry] = React.useState(false);

  React.useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (loading || (isProcessing && !user)) {
      timer = setTimeout(() => setShowRetry(true), 10000);
    } else {
      setShowRetry(false);
    }
    return () => clearTimeout(timer);
  }, [loading, isProcessing, user]);

  if (loading || (isProcessing && !user)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center space-y-6">
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <div className="text-center space-y-2">
            <p className="text-sm text-muted-foreground animate-pulse">Verifica autorizzazioni...</p>
            {showRetry && (
              <div className="pt-4 animate-in fade-in duration-500">
                <p className="text-xs text-red-500 mb-4 max-w-xs">Il caricamento sta impiegando più del previsto. Potrebbe esserci un problema di connessione o il server si sta riavviando.</p>
                <button 
                  onClick={() => window.location.reload()}
                  className="px-4 py-2 bg-secondary text-secondary-foreground rounded-lg text-xs font-bold hover:opacity-80 transition-opacity"
                >
                  Forza Ricaricamento
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    console.warn('ProtectedRoute: Utente non trovato, redirect a /login', { loading, isProcessing });
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
